// extracted by mini-css-extract-plugin
export var articleCategory = "NewsListing-module--articleCategory--46bb4";
export var articleImage = "NewsListing-module--articleImage--0f050";
export var articleLink = "NewsListing-module--articleLink--ea247";
export var greenTileContainer = "NewsListing-module--greenTileContainer--94c0b";
export var grid = "NewsListing-module--grid--a4a9e";
export var listing = "NewsListing-module--listing--4bf81";
export var loadMoreButton = "NewsListing-module--loadMoreButton--f4e36";
export var newsItemContainer = "NewsListing-module--newsItemContainer--b57a1";
export var newslisting = "NewsListing-module--newslisting--b1253";
export var programContainer = "NewsListing-module--programContainer--11c73";
export var programs = "NewsListing-module--programs--b49c1";